var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5TransitionPassV2 = function SvgAv5TransitionPassV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#42BCC7",
    "data-no-stroke": "true",
    "data-no-fill": "true"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8 6 3v10l6-5Z",
    fill: "#fff",
    "data-no-stroke": "true"
  })));
};
export { SvgAv5TransitionPassV2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgZmlsbD0iIzQyQkNDNyIgZGF0YS1uby1zdHJva2U9InRydWUiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgogICAgPHBhdGggZD0iTTEyIDhMNiAzVjEzTDEyIDhaIiBmaWxsPSJ3aGl0ZSIgZGF0YS1uby1zdHJva2U9InRydWUiLz4KPC9zdmc+Cg==";